import { Snowplow2StatsTracker } from './tracker';
import { Snowplow2WindowInterface } from '../window.interface';
import { StatsDebuggerService } from '../../../service/stats-debugger/service';
import { StatsGuardService } from '../../../service/stats-guard/service';
import { WindowService } from '../../../service/window/service';

export function Snowplow2StatsTrackerFactory(): Snowplow2StatsTracker {
  return new Snowplow2StatsTracker(
    <Snowplow2WindowInterface>WindowService().getNative(),
    StatsDebuggerService(),
    StatsGuardService()
  );
}
